import {err, ok, ValidationError} from 'framework';
import type {Result, Validator} from 'framework';
import * as z from 'zod';

const MIN_SESSION_EXERCISE_SETS = 1;
const MAX_SESSION_EXERCISE_SETS = 50;
const MIN_SESSION_EXERCISE_REPS = 1;
const MAX_SESSION_EXERCISE_REPS = 500;
const MIN_SESSION_EXERCISE_REST_SECONDS = 0;
const MAX_SESSION_EXERCISE_REST_SECONDS = 3600;

export type SessionExerciseTargets = {
  readonly sets: number;
  readonly reps: number;
  readonly restSeconds: number;
};

export class SessionExerciseTargetsValidator implements Validator<SessionExerciseTargets> {
  readonly standardSchema = z.strictObject({
    sets: z.number().int().min(MIN_SESSION_EXERCISE_SETS).max(MAX_SESSION_EXERCISE_SETS),
    reps: z.number().int().min(MIN_SESSION_EXERCISE_REPS).max(MAX_SESSION_EXERCISE_REPS),
    restSeconds: z
      .number()
      .int()
      .min(MIN_SESSION_EXERCISE_REST_SECONDS)
      .max(MAX_SESSION_EXERCISE_REST_SECONDS),
  });

  validate(value: unknown): Result<SessionExerciseTargets, ValidationError> {
    const parsed = this.standardSchema.safeParse(value);
    if (!parsed.success) {
      return err(
        new ValidationError(parsed.error.issues[0]?.message ?? 'Invalid session exercise targets.'),
      );
    }
    return ok(parsed.data);
  }
}
